import { Button } from 'react-dsgov';
import styles from './stepButton.module.scss';
import { useCallback, useEffect, useState } from 'react';

interface IProps {
  steps: string[];
  initialStep?: number;
  selectedStep?: number;
  onChange?: (value: number) => void;
}

function StepButton({ steps, initialStep = 1, selectedStep, onChange = () => {} }: IProps) {
  const [currentStep, setCurrentStep] = useState(initialStep);

  const handleStepClick = useCallback((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (event.currentTarget.dataset.step) {
      const step: string = event.currentTarget.dataset.step;

      setCurrentStep(Number(step));
      onChange(Number(step));
    }
  }, []);

  useEffect(() => {
    if (selectedStep) {
      setCurrentStep(selectedStep);
    }
  }, [selectedStep]);

  return (
    <>
      <div className={styles.stepLine}></div>
      <div className={styles.stepButton}>
        <>
          {steps.map((value, index) => (
            <Button
              primary={currentStep === index + 1}
              secondary={currentStep !== index + 1}
              key={index}
              onClick={handleStepClick}
              data-step={index + 1}
            >
              {`${index + 1}. ${value}`}
            </Button>
          ))}
        </>
      </div>
    </>
  );
}

export default StepButton;
